import { StepType } from "@redotech/redo-model/advanced-flow/common";
import {
  ErrorHandlingStrategy,
  RuleActionType,
  RuleTriggerType,
} from "@redotech/redo-model/advanced-flow/rules/types";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { DefaultRule } from "../types";

/**
 * Default rule: Generate Conversation Insights
 *
 * Automatically triggers the generateConversationInsightsV2 Temporal workflow
 * whenever a new conversation is created. This populates AI-derived fields
 * (topic, sentiment, etc.) used by conditions in other rules and the inbox UI.
 *
 * hidden: true — this is a backend-only system rule; merchants do not need to
 * see or configure it. It runs silently for every new conversation.
 */
export const generateConversationInsightsRule = {
  id: "default-generate-conversation-insights",
  name: "Generate Conversation Insights",
  description:
    "Automatically generates AI conversation insights when a new conversation is created.",
  hidden: true,
  triggerType: RuleTriggerType.CONVERSATION_CREATED,

  defaultConfig: {
    defaultRuleId: "default-generate-conversation-insights",
    enabled: true,
    // Hidden rule — large sortIndex keeps it out of the way if ever surfaced.
    sortIndex: 10_000,
    configurations: {},
  },

  template: {
    name: "Generate Conversation Insights",
    description:
      "Automatically generates AI conversation insights when a new conversation is created.",
    enabled: true,
    schemaType: SchemaType.RULES_V3,
    steps: [
      {
        type: StepType.TRIGGER,
        id: "trigger",
        schemaType: SchemaType.RULES_V3,
        category: "Rules",
        key: RuleTriggerType.CONVERSATION_CREATED,
        nextId: "actions",
      },
      {
        type: StepType.RULE_ACTIONS,
        id: "actions",
        actions: [
          { actionType: RuleActionType.GENERATE_CONVERSATION_INSIGHTS },
        ],
        errorHandlingStrategy: ErrorHandlingStrategy.CONTINUE_ON_ERROR,
      },
    ],
  },
} as const satisfies DefaultRule;
